export function isWebView() {
  if (typeof window === 'undefined')
    return false
  const ua = window.navigator.userAgent
  return ua.includes('tantin') || ua.includes('tantin')
}

export const inApp = typeof window === 'undefined' ? false : isWebView()
